import { useContext } from 'react';

import { AnalyticsContext } from './AnalyticsProvider';

type Context = {
  anonymousId: string;
  isInitialized: boolean;
};

export const useAnalytics = (): Context => useContext(AnalyticsContext);
